import VueRouter from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from '../store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';

const routes = [...dashboard.routes];

window.roleWiseRoutes = {
  agent: [],
  administrator: [],
  control: [],
  coordination: [],
  monitoring: [],
};

// generateRoleWiseRoute - updates window object with agent/admin route
const generateRoleWiseRoute = route => {
  route.forEach(element => {
    if (element.children) {
      generateRoleWiseRoute(element.children);
    }
    if (element.roles) {
      element.roles.forEach(roleEl => {
        window.roleWiseRoutes[roleEl].push(element.name);
      });
    }
  });
};
// Create a object of routes
// accessible by each role.
// returns an object with roles as keys and routeArr as values
generateRoleWiseRoute(routes);

export const router = new VueRouter({ mode: 'history', routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

const TOOLZZ_CHAT_PENDING_REDIRECT = 'toolzz_chat_pending_redirect';

export const validateAuthenticateRoutePermission = (to, next, { getters }) => {
  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    if (to.name === 'toolzz_chat_consent') {
      window.sessionStorage.setItem(
        TOOLZZ_CHAT_PENDING_REDIRECT,
        window.location.href
      );
    }
    window.location = '/app/login';
    return '/app/login';
  }

  if (!to.name) {
    const userRole = user.role;
    if (['monitoring', 'control', 'coordination'].includes(userRole)) {
      return next(
        frontendURL(`accounts/${user.account_id}/reports/conversation`)
      );
    }
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  // Consent page has no accountId — enforce admin role, skip account validation
  if (to.name === 'toolzz_chat_consent') {
    if (user?.role !== 'administrator') {
      return next(frontendURL(`accounts/${user.account_id}/dashboard`));
    }
    return next();
  }

  const nextRoute = validateLoggedInRoutes(to, getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
